<div #containingDiv class="hotDocContainer">
    @if(renderTable()){
    <hot-table
        class="hot-doc-table"
        [settings]="settings">
    </hot-table>
    }

    @if (sumOfSelected$ | async; as sumOfSelected) {
    <div class="sum">
        Summa: {{ sumOfSelected }}
    </div>
    }
</div>